module.exports = __webpack_public_path__ + "static/media/alerta-infracciones-rojo.6e5b1226.svg";